import { render, staticRenderFns } from "./jtwh.vue?vue&type=template&id=57f29403&scoped=true"
import script from "./jtwh.vue?vue&type=script&lang=js"
export * from "./jtwh.vue?vue&type=script&lang=js"
import style0 from "./jtwh.vue?vue&type=style&index=0&id=57f29403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f29403",
  null
  
)

export default component.exports